import instance from '@src/api/common';

export function putUpdatePreset(id: number, queryBody) {
  return instance.put(`/v1/preset/${id}`, queryBody);
}
